import React, { Component } from 'react';

class Footer extends Component {
  render() {

    if(this.props.data){
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url} target="_blank"><i className={network.className}></i></a></li>
      })
    }

    return (
      <footer>

     <div className="row">
        <div className="twelve columns">
           <ul className="social-links">
              {networks}
           </ul>

           <ul className="copyright">
              <li>&copy; Copyright 2022 Ryan Grayson</li>
           </ul>

        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
     </div>
     <div style={{opacity:'0', fontSize:'1px'}}>
      For search indexing
      Ryan Grayson Charlottesville
      Ryan Grayson Intern
      Ryan Grason Software Developmtent Intern
      Ryan Grayson SWE Intern
      Ryan Grayson UVA
      Ryan Grayson Boulder
      Ryan Grayson University of Virginia
      Ryan Grayson Colorado
      Ryan Grayson Software Engineer
      Ryan Grayson Web Developer
      Ryan Grayson Software Engineering
      Software Engineering
      Quant
      Quantitative
      Quantitative Finance
      Quantitative Trading
      Quantitative Research
      Quantitative Analysis
      Systematic Trading
      Ryan Grayson Oracle
      Code
      Coder
      Leetcode
      Ryan Grayson Experienced Software Engineer
      Ryan Grayson Excellent
      STEM
     </div>
  </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js